import { graphql } from 'react-relay';

export const UserShortListFragment = graphql`
    fragment UserShortListFragment on Query
    @argumentDefinitions(first: { type: "Int" }, page: { type: "Int" }, filter_flexible: { type: "String" }) {
        users(page: $page, first: $first, filter_flexible: $filter_flexible) @connection(key: "UserFragment_users") {
            edges {
                cursor
                node {
                    ...UserShortFragment
                }
            }
            ...UserShortConnectionFragment
        }
    }
`;
